import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const CommercialVehicleLoansInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section commercial-vehicle-loans-fin">
                <h2 className="other-pages-title">Commercial Vehicle Loans</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/auto-commercial-vehicle-loans-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Commercial Vehicle Loans</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What are Commercial Vehicle Loans?</h2>

                <p className="info-loan-description-smco">
                    Commercial vehicle loans provide financing solutions for purchasing vehicles for business use. These loans help businesses acquire trucks, vans, buses, and other commercial vehicles without paying the full amount upfront. With competitive interest rates and flexible repayment terms, commercial vehicle loans make transportation accessible and affordable for businesses.
                    <br /><br />
                    Commercial vehicle loans cater to businesses needing trucks, vans, or fleet vehicles. These loans can be secured or unsecured, with secured loans offering lower interest rates due to collateral. The loan amount, tenure, and EMI are determined based on the vehicle's cost, down payment, and borrower's credit profile.
                    <br /> <br />
                    Interest rates for commercial vehicle loans vary from 7% to 15% per annum, depending on the lender, loan type, and borrower's creditworthiness. Commercial vehicle loans may have slightly different terms due to higher loan amounts and business considerations. Additional charges may include processing fees, insurance premiums, and documentation costs.
                    <br /><br />
                    Before applying for a commercial vehicle loan, compare offers from multiple lenders, consider your repayment capacity, and factor in total ownership costs including insurance and maintenance. Choosing the right loan ensures you get the best value for your vehicle purchase.
                    <br />
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>High loan amounts:</strong> Up to 100% financing for vehicle purchase.</li>
                        <li><strong>Flexible tenure:</strong> Repayment periods from 1 to 7 years.</li>
                        <li><strong>Quick approval:</strong> Fast processing and disbursal.</li>
                        <li><strong>Tax benefits:</strong> Interest payments may be tax-deductible for businesses.</li>
                        <li><strong>Pre-approved offers:</strong> Instant loan offers based on credit profile.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Commercial Vehicle Loans</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Commercial Vehicle Loans:</strong> For business vehicles like trucks and vans.</li>
                        <li><strong>Used Vehicle Loans:</strong> Financing for pre-owned vehicles.</li>
                        <li><strong>Fleet Financing:</strong> Loans for multiple business vehicles.</li>
                        <li><strong>Lease Financing:</strong> Alternative to purchase with ownership transfer option.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Age:</strong> Minimum 21 years, maximum 65-70 years depending on lender.</li>
                        <li><strong>Income:</strong> Stable income source with minimum salary requirements.</li>
                        <li><strong>Credit score:</strong> Good credit history with score above 650-700.</li>
                        <li><strong>Employment:</strong> Regular employment or business ownership.</li>
                        <li><strong>Documents:</strong> ID proof, address proof, income proof, and vehicle documents.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Affordability:</strong> Makes vehicle ownership accessible.</li>
                        <li><strong>Flexibility:</strong> Customizable loan terms and amounts.</li>
                        <li><strong>Convenience:</strong> Online application and quick disbursal.</li>
                        <li><strong>Business growth:</strong> Enables fleet expansion for businesses.</li>
                        <li><strong>Tax savings:</strong> Potential deductions for commercial vehicles.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default CommercialVehicleLoansInfo;
